import { Component, Input } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import * as _ from "lodash";
import SortOptions from "../../models/content-wrapper/sort-options";
import CompanyResourceType from "../../models/resource-management/company-resource-type.enum";
import { ResourceManagementService } from "../../providers/resource-management/resource-management.service";
import { UtilityService } from "../../providers/utility-service/utility-service";

/**
 * Generated class for the PhysicianSearchComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "physician-search",
  templateUrl: "physician-search.html",
})
export class PhysicianSearchComponent {
  private inputForm: FormGroup;
  parentFormGroup: FormGroup;
  inputItems: any = [];
  previousSearchTerm: string = "";
  existingData: any;

  @Input() controlName: string;
  @Input() labelText: string;
  @Input() disabled: boolean = false;
  @Input() multipleOption: boolean = false;
  @Input() required: boolean = false;
  @Input() set group(parentFormGroup: FormGroup) {
    this.parentFormGroup = parentFormGroup;
  }
  @Input() set data(incomingData: object) {
    this.existingData = incomingData;
  }

  constructor(
    private resourceManagementService: ResourceManagementService,
    private formBuilder: FormBuilder,
    public utilityService: UtilityService
  ) {}
  ngOnInit() {
    this.inputForm = this.formBuilder.group({
      input: [
        null,
        this.required ? Validators.compose([Validators.required]) : null,
      ],
    });

    if (this.disabled) {
      this.inputForm.controls["input"].disable();
    }
    this.onValueChanges();
    this.setExistingdata();
  }

  onValueChanges() {
    this.inputForm.valueChanges.subscribe((data) => {
      let selectedProvider = _.filter(
        this.inputItems,
        (x) => data.input == x.id
      );
      let val = _.isEmpty(selectedProvider) ? "" : selectedProvider[0];
      this.parentFormGroup.controls[this.controlName].setValue(val);
    });
  }

  onClear() {
    this.inputItems = [];
    this.previousSearchTerm = "";
  }

  setExistingdata() {
    if (this.existingData) {
      this.inputItems = this.inputItems.concat(this.existingData);
      this.inputForm.controls["input"].setValue(this.existingData["id"]);
    }
  }

  /**
   * This method will off UI searching technique.
   * @param term search term.
   * @param item options.
   */

  searchFun = (term: string, item: any) => {
    return true;
  };

  onKeyup(e) {
    let searchTerm = e.target.value;
    if (
      searchTerm &&
      searchTerm.length > 2 &&
      searchTerm != this.previousSearchTerm
    ) {
      this.previousSearchTerm = searchTerm;
      this.getPhysicians(searchTerm);
    }
  }
  getPhysicians(searchTerm: string) {
    this.resourceManagementService
      .getCompanyResourceSummaries(
        0,
        10000,
        searchTerm,
        new SortOptions("last_name", "asc"),
        CompanyResourceType.PROVIDER
      )
      .subscribe(
        (data) => {
          this.inputItems = [];
          let providers = _.filter(data.content, (x) => x.externalId); // valid external Id.
          this.inputItems = this.inputItems.concat(providers);
        },
        (err) => {
          this.utilityService.presentErrorToast(
            err,
            "Failed to Load Providers"
          );
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/components/physician-search/physician-search.ts